var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEfficiencyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 47,
    viewBox: "0 0 80 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5977",
    "data-name": "Rectangle 5977",
    width: 80,
    height: 47,
    fill: "#77191a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10783",
    "data-name": "Group 10783",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10782",
    "data-name": "Group 10782",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30837",
    "data-name": "Path 30837",
    d: "M57.988,4.374l3.87,3.857a2.557,2.557,0,0,1,0,3.624L44.021,29.633a2.578,2.578,0,0,1-3.636,0L26.421,15.716a2.577,2.577,0,0,0-3.637,0L.752,40.066a2.557,2.557,0,0,0,0,3.623l2.57,2.561a2.576,2.576,0,0,0,3.636,0L22.784,28.125a2.578,2.578,0,0,1,3.636,0l13.966,13.92a2.576,2.576,0,0,0,3.634,0L68.106,18.079a2.577,2.577,0,0,1,3.634,0l3.871,3.858A2.572,2.572,0,0,0,80,20.127V2.562A2.567,2.567,0,0,0,77.429,0H59.806a2.561,2.561,0,0,0-1.818,4.374",
    transform: "translate(0 0)",
    fill: "#77191a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiencyIcon);
export default __webpack_public_path__ + "static/media/EfficiencyIcon.52dc0f025f7fd76e1c2c535a377579eb.svg";
export { ForwardRef as ReactComponent };